import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "impx-page-heading uk-position-top gallery" }
const _hoisted_2 = { class: "uk-container" }
const _hoisted_3 = { class: "uk-width-1-1" }
const _hoisted_4 = { class: "uk-flex uk-flex-left" }
const _hoisted_5 = { class: "uk-light uk-position-relative uk-text-left page-title" }
const _hoisted_6 = { class: "uk-margin-remove" }
const _hoisted_7 = { class: "impx-text-large uk-margin-remove" }




export default /*@__PURE__*/_defineComponent({
  __name: 'GalleryHeading',
  props: {
      heroInfos:{}
    },
  setup(__props) {

const props = __props;
console.log(props.heroInfos)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "impx-overlay dark" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h1", _hoisted_6, _toDisplayString(props.heroInfos?.title), 1),
            _createElementVNode("p", _hoisted_7, _toDisplayString(props.heroInfos?.subtitle), 1)
          ])
        ])
      ])
    ])
  ]))
}
}

})